module.exports = __webpack_public_path__ + "static/media/erb-ditrichstejnu.a936d09d.jpg";